import { Observable, Subject, Subscription, timer } from 'rxjs';
import { Directive, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[appTimeRemaining]',
})
export class TimeRemainingDirective implements OnChanges, OnDestroy {
  @Input() futureDate: any;
  @Input() type: any;
  @Input() enableExpired: boolean = true;
  @Input() interval = 1000;
  @Input() isLiveSession = false;
  @Output() value = new EventEmitter<any>();
  @Output() done = new EventEmitter<boolean>();
  private counterSource = new Subject<any>();
  private subscription = Subscription.EMPTY;

  constructor(
    public translate: TranslateService
  ) {
    this.subscription = this.counterSource.pipe(
      switchMap(({ interval, count }) =>
        timer(0, interval).pipe(
          take(count),
          tap(() => {
            this.value.emit(this.msToTime(this.enableExpired, this.type === 'seconds' ? this.futureDate = --count : this.futureDate, this.type));
            if (count <= 0) {
              this.done.emit(true);
            }
          })
        )
      )
    ).subscribe();
  }

  ngOnChanges() {
    this.counterSource.next({ count: this.futureDate, interval: this.interval });
  }

  public startTimer() {
    this.counterSource.next({ count: this.futureDate, interval: this.interval });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private msToTime(enableExpired:any, futureDate:any, type:any): string | null {
    let expired = false;
    let msRemaining = 0;
    if (type && type === 'seconds') {
      msRemaining = Math.abs(futureDate) * 1000;
      if (futureDate < 0) {
        expired = true;
        this.done.emit(true);
      }
    } else {
      const now = new Date().getTime();
      const endDate = new Date(futureDate).getTime();
      msRemaining = endDate - now;
      if (msRemaining < 0) {
        msRemaining = now - endDate;
        expired = true;
        this.done.emit(true);
      }
    }
    const days = Math.floor(msRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((msRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((msRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((msRemaining % (1000 * 60)) / (1000));
    if (!enableExpired && expired) {
      return ``;
    }
    if (!this.isLiveSession) {
      return ` <p class="${expired ? 'text-danger' : ''}">
      ${expired ? '-' : ''}
      ${days !== 0 ? days + ' ' + this.translate.instant('general.d') + ', ' : ''}
      ${hours !== 0 ? hours + ' ' + this.translate.instant('general.h') + ', ' : ''}
      ${minutes !== 0 ? minutes + ' ' + this.translate.instant('general.m') + ', ' : ''}
      ${seconds !== 0 ? seconds + ' ' + this.translate.instant('general.sec') : ''}
      </p>`;
    } else {
      // console.log(hours)
      return ` <ul class="liveSession-remainingTime">
        <li>${(days !== 0 ? days : '0') + `<span>` + this.translate.instant('general.day') + `</span>`}</li>
        <li>${(hours !== 0 ? hours : '0') + `<span>` + this.translate.instant('general.hour') + `</span>`}</li>
        <li>${(minutes !== 0 ? minutes : '0') + `<span>` + this.translate.instant('general.minute') + `</span>`}</li>
        <li>${(seconds !== 0 ? seconds : '0') + `<span>` + this.translate.instant('general.second') + `</span>`}</li>
      </ul>`;
    }
  }

}
